// src/components/RouteErrorBoundary.js
// Error boundary genérico para rutas cargadas con React.lazy. Los error
// boundaries de React 18 exigen una clase (no hay hook equivalente) — no es
// arquitectura nueva, es el único mecanismo que existe para esto.
import React from 'react';

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error('RouteErrorBoundary:', error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, maxWidth: 480 }}>
          <h2 style={{ margin: '0 0 8px' }}>No se pudo cargar esta sección</h2>
          <p style={{ color: 'var(--text-muted, #6B7280)', margin: '0 0 14px' }}>
            Puede ser una conexión inestable o una versión nueva desplegada mientras tenías la página abierta.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ background: 'var(--primary, #4F46E5)', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 16px', font: '600 13px inherit', cursor: 'pointer' }}
          >
            Recargar la página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default RouteErrorBoundary;
